/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

export class AttendeeQuestionChoiceListItem extends React.Component {
        static initClass() {
          this.propTypes = {
            onAdd: PropTypes.func,
            // Callback for input change 
            onChange: PropTypes.func,
            onDelete: PropTypes.func,
            id: PropTypes.number,
            value: PropTypes.string,
            connectDragSource: PropTypes.func,
            label: PropTypes.string
          };
  
          this.defaultProps = {
            value: "",
            size: 6
          };
        }

        constructor(props) {
          super(props);
this.onDelete = this.onDelete.bind(this);

          // Generate unique ID to use for linking the label and the input
          this._inputId = _.uniqueId("choice-input-");
        }

        onDelete(event) {
          event.preventDefault();
          return (typeof this.props.onDelete === 'function' ? this.props.onDelete() : undefined);
        }
      
        render() {
          return <div className="attendee-question-choice">
            <div className="attendee-question-choice--label">
              {this.props.connectDragSource && this.props.connectDragSource(<i className="fa fa-bars drag-handle" aria-hidden="true"></i>)}
              <label htmlFor={this._inputId}>{this.props.label}</label>
            </div>
            <input  id={this._inputId}
                    type="text"
                    value={this.props.value}
                    placeholder="Add choice"
                    onChange={this.props.onChange}/>
            <a href="#" aria-label={`Remove choice "${  this.props.value  }"`} onClick={this.onDelete}><i className="localist-icon-trash-small"></i></a>
          </div>;
        }
      }
AttendeeQuestionChoiceListItem.initClass();
